import { lazy } from "react";
import {
  assetsLoader,
  featuredAssetsLoader,
  userAssetsLoader,
  assetsByPlatformLoader,
  assetDetailLoader,
} from "./assetLoaders";
import ErrorPage from "../../../components/UI/ErrorPage";

const AssetsPage = lazy(() => import("../../../pages/Assets"));
const UserAssetsPage = lazy(() => import("../../../pages/UserAssetPage"));
const AssetsByPlatform = lazy(() => import("../../../pages/AssetByPlatform"));
const AssetDetail = lazy(() => import("../../../pages/AssetDetails"));
const FeaturedAssetsPage = lazy(() => import("../../../pages/FeaturedAssets"));

export const assetRoutes = [
  { path: "assets", element: <AssetsPage />, loader: assetsLoader },
  {
    path: "assets-featured",
    element: <FeaturedAssetsPage />,
    loader: featuredAssetsLoader,
    errorElement: <ErrorPage />,
  },
  {
    path: "assets/market/:username",
    element: <UserAssetsPage />,
    loader: userAssetsLoader,
    errorElement: <ErrorPage />,
  },
  { path: "assets/new", element: <AssetsPage />, loader: assetsLoader },
  {
    path: "assets/categories/:platform",
    element: <AssetsByPlatform />,
    loader: assetsByPlatformLoader,
    errorElement: <ErrorPage />,
  },
  {
    path: "assets/categories/:platform/:category",
    element: <AssetsByPlatform />,
    loader: assetsByPlatformLoader,
    errorElement: <ErrorPage />,
  },
  {
    path: "asset/categories/:platform",
    element: <AssetsByPlatform />,
    loader: assetsByPlatformLoader,
    errorElement: <ErrorPage />,
  },
  {
    path: "assets/:id",
    element: <AssetDetail />,
    loader: assetDetailLoader,
    errorElement: <ErrorPage />,
  },
];
